import moment from 'moment';
import { parsePaymentPaidAt } from '#app/helpers/dateFieldTransforms';

// const addMonth = (years, monthKey, indexDate, indexYearMonth, sign) => {
//   let month = moment.months()[monthKey];
//   var months = [
//     'january',
//     'february',
//     'march',
//     'april',
//     'may',
//     'june',
//     'july',
//     'august',
//     'september',
//     'october',
//     'november',
//     'december',
//   ];

//   indexDate[monthKey] = [];
//   indexYearMonth.push(month);

//   years.months[monthKey] = {
//     name: month,
//     nameEng: months[monthKey],
//     sum: 0,
//     sign: sign,
//     dates: [],
//   };
// };

const MONTHS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const initializeYear = (year, currencySign) => ({
  name: year,
  sum: 0,
  months: MONTHS.map((monthEng, index) => ({
    name: moment.months()[index],
    nameEng: monthEng,
    sum: 0,
    sign: currencySign,
    dates: [],
  })),
  sign: currencySign,
});

const initializeDate = (date, dateEng, currencySign) => ({
  name: date,
  nameEng: dateEng,
  sum: 0,
  sign: currencySign,
  items: [],
});

export const prepareYears = (
  years,
  actives,
  callbackItem,
  paidField,
  sumField,
  getCurrencySign,
  getPassItem,
  operation
) => {
  const yearIndex = {};

  actives.forEach((active) => {
    callbackItem(active, (item) => {
      const paidDate = parsePaymentPaidAt(item, paidField);
      if (!paidDate) return;
      const year = paidDate.format('YYYY');
      const monthName = paidDate.format('MMMM');
      const monthIndex = paidDate.month(); // 0-11
      const dateStr = paidDate.format('D MMMM');
      const dateEng = paidDate.format('D') + MONTHS[monthIndex];
      const amount = item[sumField];
      const currencySign = getCurrencySign(item);

      // Initialize year if not exists
      if (!yearIndex[year]) {
        yearIndex[year] = {
          yearObj: initializeYear(year, currencySign),
          monthIndices: {},
          dateIndices: Array(12)
            .fill()
            .map(() => ({})),
        };
        years.push(yearIndex[year].yearObj);
      }

      const { yearObj, monthIndices, dateIndices } = yearIndex[year];

      // Update year sum
      yearObj.sum = operation(yearObj.sum, amount);

      // Get month object
      const monthObj = yearObj.months[monthIndex];

      // Update month sum
      monthObj.sum = operation(monthObj.sum ?? 0, amount);

      // Find or create date entry
      let dateIndex = monthIndices[dateStr];
      if (dateIndex === undefined) {
        dateIndex = monthObj.dates.length;
        monthIndices[dateStr] = dateIndex;
        monthObj.dates.push(initializeDate(dateStr, dateEng, currencySign));
      }

      // Update date entry
      const dateObj = monthObj.dates[dateIndex];
      dateObj.items.push(getPassItem(active, item));
      dateObj.sum = operation(dateObj.sum, amount);
    });
  });
};
